import React from 'react';
import { formatDateTime } from '../../../utils/DateHelper';
import { IFormatterProps } from '../../../@types/workspaceTypes';

const DateTimeFormatter = ({ dependentValues, value }: IFormatterProps<any>) => {
  if (!dependentValues.rowData) return <div />;

  const dateTime = formatDateTime(value ? value : '');

  return (
    <div className="" style={{ textAlign: 'left' }} title={dateTime}>
      {dateTime}
    </div>
  );
};

export default DateTimeFormatter;
